import { useSelector } from 'react-redux'

import type { Props as FAQModuleProps } from 'ui-component-library/components/FAQModule'
import { getGeneralStrings } from 'store/strings/selectors'
import FAQModule from 'ui-component-library/components/FAQModule'

type Props = Omit<FAQModuleProps, 'moreText' | 'lessText'>

function FAQModuleContainer(props: Props) {
  const { lessText, moreText } = useSelector(getGeneralStrings)
  return <FAQModule lessText={lessText} moreText={moreText} {...props} />
}

export default FAQModuleContainer
